import React from "react";
import PageHero from "../components/PageHero";
import ServicesGrid from "../components/ServicesGrid";
import CyberRiskCTA from "../components/CyberRiskCTA";
import AssessmentTimeline from "../components/AssessmentTimeline";

export default function ServicesPage() {
  return (
    <div data-testid="services-page">
      <PageHero
        eyebrow="Services"
        title="Consulting + engineering across the security lifecycle"
        subtitle="From CISO-as-a-service and compliance readiness to 24×7 managed security operations — we scope every engagement to your business risk and regulatory obligations."
      />
      <ServicesGrid />
      <AssessmentTimeline />
      <CyberRiskCTA />
    </div>
  );
}
